import { postApi, getApi } from '@coconut/services/apis/utils';

export const appLaunch = (lang) =>
  postApi('api/v2/app_launch', {
    data: {
      lang,
    },
  }).then((res) => res);

export const fetchSiteInfo = () =>
  getApi('api/v3/web/guest/site_info').then((res) => res.data);

export const logout = () => postApi('api/v2/logout');



// WEBPACK FOOTER //
// ./src/services/apis/app.js